export default __webpack_public_path__ + "static/media/maduro-5Closed.9f3752a0.jpg";